const BITRIX_POST_AUTH_ROUTE_KEY = 'bitrix24_post_auth_route'
const BITRIX_BOOTSTRAP_ROUTE_KEY = '__bitrix24BootstrapRoute'
const BITRIX_SDK_SRC = 'https://api.bitrix24.com/api/v1/'

let bitrixSdkPromise = null

export const isBitrix24Mode = () => {
	try {
		return (
			localStorage.getItem('bitrix24_mode') === 'true' ||
			window.self !== window.top
		)
	} catch (_) {
		return true
	}
}

export const saveBitrixPostAuthRoute = route => {
	if (typeof route !== 'string' || !route.startsWith('/')) {
		return
	}

	localStorage.setItem(BITRIX_POST_AUTH_ROUTE_KEY, route)
}

export const getBitrixPostAuthRoute = () =>
	localStorage.getItem(BITRIX_POST_AUTH_ROUTE_KEY) || ''

export const consumeBitrixPostAuthRoute = () => {
	const route = getBitrixPostAuthRoute()
	if (route) {
		localStorage.removeItem(BITRIX_POST_AUTH_ROUTE_KEY)
	}

	return route
}

export const getBitrixBootstrapRouteFromWindowName = () => {
	try {
		if (!window.name) return ''
		const payload = JSON.parse(window.name)
		const route = payload?.[BITRIX_BOOTSTRAP_ROUTE_KEY]
		return typeof route === 'string' && route.startsWith('/') ? route : ''
	} catch (_) {
		return ''
	}
}

export const clearBitrixBootstrapRouteFromWindowName = () => {
	try {
		if (!window.name) return
		const payload = JSON.parse(window.name)
		if (!payload || typeof payload !== 'object' || !payload[BITRIX_BOOTSTRAP_ROUTE_KEY]) {
			return
		}

		delete payload[BITRIX_BOOTSTRAP_ROUTE_KEY]
		window.name = Object.keys(payload).length ? JSON.stringify(payload) : ''
	} catch (_) {
		window.name = ''
	}
}

export const ensureBitrix24Sdk = () => {
	if (typeof window === 'undefined' || !isBitrix24Mode()) {
		return Promise.resolve(false)
	}

	if (typeof window.BX24?.openApplication === 'function') {
		return Promise.resolve(true)
	}

	if (bitrixSdkPromise) {
		return bitrixSdkPromise
	}

	const initializeSdk = resolve => {
		if (typeof window.BX24?.openApplication === 'function') {
			resolve(true)
			return
		}

		if (typeof window.BX24?.init === 'function') {
			try {
				window.BX24.init(() => {
					resolve(typeof window.BX24?.openApplication === 'function')
				})
				return
			} catch (_) {
				resolve(false)
				return
			}
		}

		resolve(false)
	}

	bitrixSdkPromise = new Promise(resolve => {
		const existingScript = document.querySelector(`script[src="${BITRIX_SDK_SRC}"]`)
		if (existingScript) {
			if (typeof window.BX24 !== 'undefined') {
				initializeSdk(resolve)
				return
			}

			existingScript.addEventListener('load', () => initializeSdk(resolve), { once: true })
			existingScript.addEventListener('error', () => resolve(false), { once: true })
			return
		}

		const script = document.createElement('script')
		script.src = BITRIX_SDK_SRC
		script.async = true
		script.onload = () => initializeSdk(resolve)
		script.onerror = () => resolve(false)
		document.head.appendChild(script)
	}).finally(() => {
		bitrixSdkPromise = null
	})

	return bitrixSdkPromise
}

export const closeBitrixSlider = async () => {
	const isReady = await ensureBitrix24Sdk()
	if (!isReady || typeof window.BX24?.closeApplication !== 'function') {
		return false
	}

	window.BX24.closeApplication()
	return true
}

export const openInternalRouteInContext = (router, routeLocation, options = {}) => {
	const resolvedRoute = router.resolve(routeLocation)
	const routeHref = resolvedRoute?.href

	if (!routeHref) {
		return false
	}

	if (isBitrix24Mode()) {
		const sliderParams = {
			appRoute: routeHref,
		}

		if (options.title) {
			sliderParams.bx24_title = options.title
		}

		if (Number.isFinite(options.width)) {
			sliderParams.bx24_width = options.width
		}

		if (Number.isFinite(options.leftBoundary)) {
			sliderParams.bx24_leftBoundary = options.leftBoundary
		}

		ensureBitrix24Sdk().then(isReady => {
			if (isReady && typeof window.BX24?.openApplication === 'function') {
				window.BX24.openApplication(sliderParams, options.closeCallback || (() => {}))
				return
			}

			router.push(routeLocation)
		})
		return true
	}

	window.open(routeHref, options.target || '_blank', options.windowFeatures || 'noopener')
	return false
}
